import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

const KEY = "syndicate369.waitlist";
const OK = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const IDLE = "Be the first to know when it opens.";

const Stroke = () => (
  <svg viewBox="0 0 200 12" preserveAspectRatio="none" aria-hidden="true">
    <path d="M1.2 8.4C50 4.6 120 2.4 198.4 3.6c1.4.1 1.5 2.2.1 2.4C124 8.2 54 10.6 2 11.6c-1.6 0-2.3-2.9-.8-3.2Z" />
  </svg>
);

export default function Waitlist() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(IDLE);
  const [bad, setBad] = useState(false);
  const [busy, setBusy] = useState(false);
  const [joined, setJoined] = useState(() => {
    try { return !!localStorage.getItem(KEY); } catch (e) { return false; }
  });

  useEffect(() => {
    document.title = "Syndicate 369";
  }, []);

  const onChange = (e) => { setEmail(e.target.value); setBad(false); setMsg(IDLE); };

  const submit = async (e) => {
    e.preventDefault();
    const mail = email.trim();
    if (!OK.test(mail)) { setBad(true); setMsg("That email doesn’t look right."); return; }
    setBusy(true); setBad(false); setMsg("Adding you…");
    try {
      await api.post(`${API}/waitlist`, { email: mail });
      try { localStorage.setItem(KEY, mail); } catch (err) { /* private mode */ }
      setJoined(true);
    } catch (err) {
      setBad(true); setMsg("That didn’t go through. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="s369" data-testid="waitlist-page">
      <main>
        <img className="eye" src="/media/eye-black.webp" alt="Syndicate 369: the eye in the triangle" width="1400" height="1088" />
        <h1 data-testid="waitlist-title">Syndicate 369</h1>
        <p className="sub">
          <span className="ln">Seeing what others <span className="u">don’t<Stroke /></span></span>
          <span className="ln">unlocks everything.</span>
        </p>

        {joined ? (
          <div className="done" role="status" aria-live="polite" data-testid="waitlist-success">
            <b>You’re in.</b><span>We’ll email you when it opens.</span>
          </div>
        ) : (
          <>
            <form className={bad ? "bad" : ""} onSubmit={submit} noValidate data-testid="waitlist-form">
              <label htmlFor="email" className="sr">Email</label>
              <input id="email" type="email" inputMode="email" autoComplete="email" placeholder="Put your email in"
                value={email} onChange={onChange} data-testid="waitlist-email-input" />
              <button type="submit" disabled={busy} data-testid="waitlist-join-button">
                Join <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
              </button>
            </form>
            <p className={`msg ${bad ? "err" : ""}`} role="status" aria-live="polite" data-testid="waitlist-message">{msg}</p>
          </>
        )}
      </main>
      <footer><span>III · VI · IX</span></footer>
    </div>
  );
}
